import React, { useEffect, useMemo, useState } from "react"
import { get, isEmpty, includes } from "lodash"

import * as Formatter from "utils/Formatter"
import { APIResponse } from "redux/apis/types"
import PushSymbol from "components/molecules/pushSymbol"
import { GetTicketKey } from "node-dist/nodeDistFlag"
import ClassNames from "classnames"
import store from "redux/store"
import { showSymbol } from "redux/ducks/SymbolDetail"
import { EXCHANGE, FOREIGN_STOCK, SECURITY_TYPE } from "config/const"
import {
  getCountryIcon,
  getPriceCompareText,
  priceCompareIcon,
  checkIsSp,
  open_symbol_detail,
  getPriceOrLastClose,
} from "utils/util"

export const PriceDetail = () => {
  return (
    <div className="price-detail-col">
      <div className="price-detail-row">
        <div className="price-detail-title">
          <i className="icon-solid icon-jp icon-m" />
          日経平均
        </div>
        <div className="price-detail-value-col right-justify">
          <div className="price-detail-currency-col">
            <div className="price-detail-currency-title">現在値</div>
            <div className="price-detail-currency-value">20,625.16</div>
            <i className="material-icons up">arrow_upward</i>
          </div>
          <div className="time-col">09/03 15:15</div>
        </div>
      </div>
      <div className="price-detail-row">
        <div className="price-detail-value-col right-justify">
          <div className="price-detail-currency-col">
            <div className="price-detail-currency-title">前日比 (%)</div>
            <div className="price-detail-change-price-col">
              <div className="price-detail-change-price up">+84.18</div>
              <div className="price-detail-change-ratio">
                (<span className="up">+0.41</span>
                <span className="unit">%</span>)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

type PriceDetailContentType = {
  data: APIResponse.Res
  middleChartFlag?: boolean
  numberOfStocks?: number
  oneLineType?: boolean
  movingDataItem?: {
    active: number
    changeData: Function
    total: number
    setFlag?: Function
  }
}

export const PriceDetailContent: React.FC<PriceDetailContentType> = props => {
  const [priceCompareText, setPriceCompareText] = useState("")
  const {
    numberOfStocks,
    oneLineType,
    movingDataItem,
    data,
    middleChartFlag,
  } = props
  const bondFlag = useMemo(() => {
    return get(data, "Exchange", null) === 13000
  }, [data])
  const labelVisible = useMemo(() => {
    const targetSecurityType = get(data, "SecurityType")
    return (
      includes(FOREIGN_STOCK, targetSecurityType) ||
      SECURITY_TYPE.Equity.id === targetSecurityType
    )
  }, [data])
  const icon = useMemo(() => {
    const targetSecurityType = get(data, "SecurityType")
    if (
      !middleChartFlag ||
      // 商品はアイコン非表示
      includes(
        [14113, 14201, 14001, 14002, 14101, 14102, 14111, 14112],
        targetSecurityType
      )
    )
      return null
    return getCountryIcon(data)
  }, [data, middleChartFlag])
  const isSp = useMemo(() => {
    return checkIsSp()
  }, [])

  useEffect(() => {
    get(data, "PriceCompare")
      ? getPriceCompareText(
          get(data, "PriceCompare"),
          priceCompareText,
          setPriceCompareText
        )
      : setPriceCompareText("")
  }, [data])

  const priceCompare = get(data, "PriceCompare")
  const iconClass: string = priceCompareIcon(priceCompare)
  const NumberOfDecimals = get(data, "NumberOfDecimals", 0)

  //為替,国債,商品（金現物,銀現物）はPriceがnullの場合はLastClose,LastCloseTimeを使用する
  const [_price, _priceTime] = getPriceOrLastClose(data)
  const symbolsUseGetPriceOrLastClose = includes(
    [EXCHANGE.FX.id, EXCHANGE.GB.id, EXCHANGE.XAU_XAG.id],
    get(data, "Exchange")
  )

  return (
    <div className="price-detail-col">
      <div
        className={ClassNames("price-detail-row", {
          "one-line": !!oneLineType,
        })}
      >
        <div className="price-detail-title-group">
          {icon && <i className={ClassNames("icon-solid ", icon)} />}
          {labelVisible && <div className="symbol-code-label">101</div>}
          <div className="price-detail-title">
            <div className="control-row">
              {get(props.data, "SymbolNameS") || get(props.data, "SymbolName")}
              {numberOfStocks && (
                <div className="price-detail-title">
                  銘柄数：{numberOfStocks}
                </div>
              )}
            </div>
          </div>
          {// TODO アイコンは見直しが必要。
          props.middleChartFlag && (
            <span
              className={ClassNames("btn-symbol-detail right-justify", {
                flex: movingDataItem,
              })}
            >
              {movingDataItem && (
                <div className="data-moving-contents">
                  <div
                    className={ClassNames(
                      "btn btn-primary btn-shaped btn-detail",
                      { disable: get(movingDataItem, "active") === 0 }
                    )}
                    onClick={() => {
                      if (get(movingDataItem, "active") === 0) {
                        return
                      }
                      get(movingDataItem, "setFlag") &&
                        get(movingDataItem, "setFlag")(true)
                      get(movingDataItem, "changeData")(
                        get(movingDataItem, "active") - 1
                      )
                    }}
                  >
                    <i className="material-icons">chevron_left</i>
                  </div>
                  <div
                    className={ClassNames(
                      "btn btn-primary btn-shaped btn-detail",
                      {
                        disable:
                          get(movingDataItem, "active") ===
                          get(movingDataItem, "total") - 1,
                      }
                    )}
                    onClick={() => {
                      if (
                        get(movingDataItem, "active") ===
                        get(movingDataItem, "total") - 1
                      ) {
                        return
                      }
                      get(movingDataItem, "setFlag") &&
                        get(movingDataItem, "setFlag")(true)
                      get(movingDataItem, "changeData")(
                        get(movingDataItem, "active") + 1
                      )
                    }}
                  >
                    <i className="material-icons">chevron_right</i>
                  </div>
                </div>
              )}
              {/*指数であれば銘柄詳細への遷移はさせない*/}
              {get(props.data, "SecurityType") !== SECURITY_TYPE.Index.id && (
                <div
                  className="btn btn-primary btn-shaped btn-detail"
                  onClick={async () => {
                    await store.dispatch(showSymbol(props.data))
                    if (!isSp) open_symbol_detail(props.data)
                  }}
                  title={"銘柄詳細"}
                >
                  <i className="material-icons">library_books</i>
                </div>
              )}
            </span>
          )}
        </div>
        <div className="price-detail-value-col right-justify row-type-one">
          <div className="price-detail-currency-col">
            <div className="price-detail-currency-title">
              {bondFlag && "利回り"}
            </div>
            <div className="price-detail-currency-value">
              {Formatter.number(
                symbolsUseGetPriceOrLastClose
                  ? _price
                  : get(data, "Price", null),
                2
              )}
            </div>
            <i
              className={ClassNames("material-icons", iconClass, {
                empty: isEmpty(priceCompareText),
              })}
            >
              {priceCompareText}
            </i>
          </div>
          <div className="price-detail-currency-col">
            {/*TODO:ミドルチャート：レイアウト調整中*/}
            {/*<div className="price-detail-currency-title">前日比 (%)</div>*/}
            <div className="price-detail-change-price-col">
              <div
                className={ClassNames(
                  "price-detail-change-price",
                  Formatter.upDown(get(data, "ChangedPrice"))
                )}
              >
                {Formatter.number(
                  get(data, "ChangedPrice", null),
                  2,
                  "floor",
                  true
                )}
              </div>
              {!bondFlag && (
                <div className="price-detail-change-ratio">
                  (
                  <span
                    className={ClassNames(
                      Formatter.upDown(get(data, "ChangedRatio"))
                    )}
                  >
                    {Formatter.number(
                      get(data, "ChangedRatio", null),
                      2,
                      "floor",
                      true
                    )}
                  </span>
                  <span className="unit">%</span>)
                </div>
              )}
            </div>
          </div>
          <div className="time-col">
            {Formatter.date(
              symbolsUseGetPriceOrLastClose
                ? _priceTime
                : get(data, "PriceTime"),
              "HH:mm"
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
